// extracted by mini-css-extract-plugin
export default {"titlewrap":"ImgHeader_titlewrap__RGkMq","imgWrapTitle":"ImgHeader_imgWrapTitle__M9UfG","header":"ImgHeader_header__VvZ4h"};